import { PositionType } from '../../../lib/defs/types';
import type { QueriesObject, QueryResults, System } from '../../../odie';
import { BasicBlockComponent } from '../../components/BasicBlockComponent';
import type { BlockEntity } from '../../entities/BlockEntity';
import type { GameScene } from '../../GameScene';
import { GrassBlockComponent } from './GrassBlockComponent';

const surroundingPositionDiffs: PositionType[] = [
  { x: -1, y: 0 },
  { x: 1, y: 0 },
  { x: 0, y: -1 },
  { x: 0, y: 1 },
];

export class GrassBlockSystem implements System {
  public static readonly NAME = 'grassBlock';
  public static Queries: QueriesObject = {
    block: {
      components: [BasicBlockComponent],
      removed: true,
    },
    grassBlocks: {
      components: [GrassBlockComponent],
    },
  };
  public scene!: GameScene;
  public queries!: QueryResults;

  public removedFromQuery(entity: BlockEntity) {
    if (this.scene.isApplyingExtraPowerups) return;
    if (entity.c.block.props.type !== 'basic') return;
    if (this.queries.grassBlocks.entities.length === 0) return;
    this.clearSurroundingGrassBlocks(entity);
  }

  private clearSurroundingGrassBlocks(entity: BlockEntity) {
    for (const position of surroundingPositionDiffs) {
      this.clearGrassBlockOverEmptyCell(entity, position);
    }
  }

  private clearGrassBlockOverEmptyCell(
    entity: BlockEntity,
    positionDiff: PositionType,
  ) {
    const mapComponent = this.scene.sessionEntity.c.map;
    const position = entity.c.position.mapPosition;
    const cell = mapComponent.getCellAt({
      x: position.x + positionDiff.x,
      y: position.y + positionDiff.y,
    });

    if (!cell) return;
    if (cell.base?.entity) return;

    const overlayEntity = cell.overlay?.entity;
    if (overlayEntity?.c.block.blockId !== 'grass') return;
    if (!overlayEntity?.c.view2d) return;
    if (overlayEntity.c.view2d.view.alpha < 1) return;

    overlayEntity.c.block.collide('attack');
  }
}
